import React from "react";
import RightAboutParaSection2 from "./RightAboutParaSection2";

const RightAboutSection2 = () => {
  return (
    <div className="right lg:mx-6 lg:w-[60%] ">
      <div className="mt-56 lg:mt-72">
        <div className="leading-7">
          <h1 className="text-4xl font-semibold ">General rules</h1>
          <hr className="mt-6 border-black" />
          <RightAboutParaSection2 para="All students must sing the School Song with pride and respect."/>
          <hr className="mt-6 border-black" />
          <RightAboutParaSection2 para="Maintain highest standards of cleanliness at all times on the school premises. Cleanliness includes the maintenance of the immediate surrounding areas."/>
          <hr className="mt-6 border-black" />
          <RightAboutParaSection2 para="Students must wear the prescribed school uniform and any modification is strictly not allowed "/>
          <hr className="mt-6 border-black" />
          <RightAboutParaSection2 para="Students are urged to contribute to the tone of the school by their manners and general behavior."/>
        </div>
        <div className="mt-4">
          <img
            className="w-full lg:w-full"
            src="https://www.stickergenius.com/wp-content/uploads/2020/09/back2school-covid-BLACK-09.jpg"
            alt=""
          />
        </div>
      </div>
    </div>
  );
};

export default RightAboutSection2;
